module.exports = __webpack_public_path__ + "static/media/coll-cover-small.30be5303.jpg";